'use client';

import dynamic from 'next/dynamic';

const ConfettiGeyser = dynamic(
  () =>
    import('./ConfettiGeyser').catch((err) => {
      // If the internet connection is lost, we won’t be able to load the ConfettiGeyser component, but that’s fine.
      return { default: () => null };
    }),
  {
    ssr: false,
  }
);

export default ConfettiGeyser;
